import type { ReactNode } from 'react';

type PriceProps = {
  price: string;
};

/**
 * The price display inside the betslip.
 *
 * @param root0 input object
 * @param root0.price the current price to display.
 * @returns a div with the price inside.
 */
export default function BetslipPrice({ price }: PriceProps): ReactNode {
  return (
    <div
      className="grid items-center justify-self-end font-bold [grid-area:price] lg:justify-self-center"
      data-testid="priceInfo"
    >
      {price}
    </div>
  );
}
